import FlexMainWrapper from '../../designComponents/wrappers/FlexMainWrapper';
import {InputTitle} from '../../designComponents/inputs/InputLine';
import {TextArea} from '../../designComponents/inputs/TextArea';
import {MainButton} from '../../designComponents/buttons/Buttons';
import {SText} from '../../designComponents/text/ContentText';
import {MainSelect} from '../../designComponents/dropdowns/Selectdown';
import {isEmptyObj} from '../../utils/textFilter';
import TypeComponent from '../../components/PushAlarm/TypeComponent';
import React, {useEffect, useRef, useState} from 'react';
import {UserCountNumber} from '../SMS/SendSMS';
import RefreshCheckApi from '../../communication_system/axios_apis/refresh_check/refresh_check_api';
import {SinorPushScreenTypes, SirupPushScreenTypes} from '../../components/PushAlarm/PushScreenTypes';

export const PushAlarmTypes = {
    USER: 0,
    ALARM: 1,
    MARKETING: 2,
    ID: 3,
    PHONE: 4,
};
export const PushPlatformTypes = {
    SIRUP: 1,
    SINOR: 2,
};
const SendPush = ({ platform, userIdList = [], type }) => {
    const [movePages, setMovePages] = useState([]);
    const [currentParam, setCurrentParam] = useState({});
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [param, setParam] = useState({ title: '', content: '' });

    const paramsRef = useRef(null);

    useEffect(() => {
        setParam((prev) => {
            return {
                ...prev,
                targetList: userIdList,
                platform: platform,
            };
        });
    }, [userIdList, platform]);
    useEffect(() => {
        setMovePages(platform === PushPlatformTypes.SIRUP ? SirupPushScreenTypes : SinorPushScreenTypes);
        setCurrentParam(platform === PushPlatformTypes.SIRUP ? SirupPushScreenTypes[0] : SinorPushScreenTypes[0]);
    }, [platform]);
    useEffect(() => {
        paramsRef.current = {};
    }, [currentParam, platform]);
    return (
        <>
            <FlexMainWrapper style={{ alignItems: 'start', marginBottom: '10px', gap: '20px' }}>
                <FlexMainWrapper style={{ flexDirection: 'column', alignItems: 'start', width: '65%' }}>
                    <InputTitle
                        exposure={false}
                        placeholder="제목을 입력해주세요."
                        wrapperStyle={{ margin: 0, width: '100%' }}
                        inputStyle={{ width: '100%' }}
                        onChange={(e) => {
                            setTitle(e.target.value);
                        }}
                    />
                    <TextArea
                        style={{ width: '100%', marginBottom: '5px' }}
                        placeholder={'내용을 입력해 주세요.'}
                        onChange={(e) => {
                            setContent(e.target.value);
                        }}
                    />
                    <FlexMainWrapper style={{ justifyContent: 'end', width: '100%' }}>
                        {type === PushAlarmTypes.USER && <UserCountNumber count={userIdList.length}></UserCountNumber>}
                        <MainButton
                            text="앱 푸시 발송"
                            width={100}
                            onClick={async () => {
                                try {
                                    const data = {
                                        data: {
                                            params: {},
                                        },
                                        title,
                                        content,
                                        type,
                                    };
                                    if (type === PushAlarmTypes.USER || type === PushAlarmTypes.ID || type === PushAlarmTypes.PHONE) {
                                        data.targetList = param.targetList;
                                    }
                                    if (platform === PushPlatformTypes.SINOR) {
                                        data.data.platform = 'gathering';
                                    }
                                    if (currentParam.page) {
                                        data.data.page = currentParam.page;
                                    }

                                    Object.keys(paramsRef.current?.paramsData).forEach((key) => {
                                        const value = (currentParam.params[key]?.preFix ?? '') + paramsRef.current?.paramsData[key];
                                        if (/^params./.test(key)) {
                                            data.data.params[key.replace(/^params./, '')] = value;
                                        } else {
                                            data.data[key] = value;
                                        }
                                    });
                                    if (Object.keys(data.data.params).length === 0) {
                                        delete data.data.params;
                                    } else {
                                        data.data.params = JSON.stringify(data.data.params);
                                    }
                                    if (window.confirm('푸시 알람을 전송하시겠습니까?')) {
                                        const res = await RefreshCheckApi.post('/adminPush', data);
                                        if (res.status === 200 && res.data.ok) alert('푸시 알람 전송 성공');
                                    }
                                } catch (error) {
                                    console.error('error: ', error);

                                    if (error?.response?.status === 400) {
                                        alert(`알람 전송 싫패! \n사유: ${error?.response?.data?.message || '서버 에러!'}`);
                                    } else {
                                        alert('[Error]서버 관리자에게 문의 바랍니다.');
                                    }
                                }
                            }}
                        />
                    </FlexMainWrapper>
                </FlexMainWrapper>

                <FlexMainWrapper style={{ flexDirection: 'column', alignItems: 'start', width: '35%' }}>
                    <FlexMainWrapper style={{ alignItems: 'center', justifyContent: 'start', width: '100%' }}>
                        <SText text={'이동 페이지'} style={{ width: '100px', fontWeight: 'bold' }} color={'#797979'} />

                        <MainSelect
                            title={'name'}
                            itemKey={'name'}
                            list={movePages}
                            style={{ width: '210px', height: '31px', padding: '0 3px' }}
                            resetThenSet={(target) => {
                                const [params] = movePages.filter((v) => v.name === target.value);
                                if (params) {
                                    setCurrentParam(params);
                                }
                            }}
                        />
                    </FlexMainWrapper>
                    {isEmptyObj(currentParam) ? <TypeComponent types={currentParam.params} ref={paramsRef} /> : null}
                </FlexMainWrapper>
            </FlexMainWrapper>
        </>
    );
};

export default SendPush;
